<template>
  <div class="top_ackkitchen">
    <div class="top_ackkitchen_a">
      <el-dropdown class="top_ackkitchen_as" placement="bottom-start">
        <img class="el-dropdown-link topImg" src="../../assets/topicon.png" />
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="item in typeDate" :key="item.id">
            <div @click="setdropdown(item)">{{ item.name }}</div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>永信智慧餐厅后厨数据中心
    </div>
    <div class="name_body">

      <el-row :gutter="20">
        <el-col :span="18">
          <el-row :gutter="10">
            <el-col class="colMaxBox" :lg="6" :md="12"
            ><div class="grid-content bg-purple">
              <div class="top_item">
                <div class="item_name">
                  营业额
                </div>
                <div class="item_value">¥ {{(total_sale/100.0).toFixed(2)}}</div>
              </div>
            </div>
            </el-col>
            <el-col class="colMaxBox" :lg="6" :md="12"
            ><div class="grid-content bg-purple">
              <div class="top_item">
                <div class="item_name">
                  服务人次
                </div>
                <div class="item_value">{{client_stat}}</div>
              </div>
            </div>
            </el-col>
            <el-col class="colMaxBox" :lg="6" :md="12"
            ><div class="grid-content bg-purple">
              <div class="top_item">
                <div class="item_name">
                  平均客单价
                </div>
                <div class="item_value">¥ {{(per_client_sale/100.0).toFixed(2)}}</div>
              </div>
            </div>
            </el-col>
            <el-col class="colMaxBox" :lg="6" :md="12">
              <div class="grid-content bg-purple">
              <div class="top_item">
                <div class="item_name">
                  菜品数量
                </div>
                <div class="item_value">{{dish_count}}</div>
              </div>
            </div>
            </el-col>
          </el-row>
          <div class="name_body_top">
              <div id="echart_A" style="width: 100%; height: 300px"></div>
          </div>
          <div class="name_body_bottom">
            <div class="name_body_bottom_list" v-for="(item, index) in deviceList" :key="index">
              <div class="name_body_bottom_name">
                <div class="dish_name" v-if="item.level === 2" style="background-color: #ff6827">{{ item.dish_name }}</div>
                <div class="dish_name" v-if="item.level === 1" style="background-color: #f6bb07">{{ item.dish_name }}</div>
                <div class="dish_name" v-if="item.level === 0" style="background-color: #3fb903">{{ item.dish_name }}</div>
              </div>
              <div :id="`echartsDemos${index}`" style="display: flex">
                <div class="name_body_bottom_f">
                  <img v-for="(items, index) in item.weight" :key="index" :src="items" />
                </div>
                <div style="margin-left: 5px; margin-top: 25px; font-size: large; font-weight: bold">kg</div>
              </div>
              <div class="name_body_icon">
                <img src="../../assets/list_icon.png" />
                <div>{{ item.volume_real}}KG</div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-contents">
            <div class="contents_name">菜品销量排行</div>
            <div class="contents_list">
              <div class="borderB">
                <div class="contents_list_as">排名</div>
                <div class="contents_list_b" style="flex: 1; margin-left: 20px">菜品名称</div>
                <div class="contents_list_b" style="width: 80px">销售额</div>
              </div>
            </div>
            <div class="contents_list" v-for="(item, index) in contentsList" :key="index">
              <div class="contents_list_a">{{ index + 1 }}</div>
              <div class="contents_list_b" style="flex: 1; margin-left: 20px">{{ item.name }}</div>
              <div class="contents_list_b" style="width: 120px">{{ (item.total_price / 100).toFixed(2) }}元</div>
            </div>
          </div>
          <div class="grid-contents" style="max-height: 300px">
            <div class="contents_name">餐炉取餐排行</div>
            <div class="contents_list">
              <div class="borderB">
                <div class="contents_list_as">排名</div>
                <div class="contents_list_b" style="flex: 1; margin-left: 20px">餐炉编号</div>
                <div class="contents_list_b" style="width: 120px">销售额</div>
              </div>
            </div>
            <div class="contents_list" v-for="(item, index) in deviceWeights" :key="index">
              <div class="contents_list_a">{{ index + 1 }}</div>
              <div class="contents_list_b" style="flex: 1; margin-left: 20px">{{ item.name }}</div>
              <div class="contents_list_b" style="width: 80px">{{ (item.total_price / 100).toFixed(2) }}元</div>
            </div>
            <!-- deviclist -->
          </div>
          <div class="grid-contents date_value" style="max-height: 300px">
            <div>
              <img v-for="(items, intIndex) in date" :key="intIndex" :src="items" class="date_img" />
            </div>
            <div class="date_name">{{ information.data }}</div>
            <div class="date_names">{{manager.position}}</div>
            <div class="date_name">{{manager.name}}</div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'dailymenu',
  data() {
    return {
      content: '',
      bottomList: [],
      deviceList: [],
      deviceWeights: [],
      periods:[],
      numberImg: [
        {
          name: ':',
          value: this.$userList.image_url + '/timesp1.png',
        },
        {
          name: '.',
          value: this.$userList.image_url + '/numdot.png',
        },
        {
          name: '0',
          value: this.$userList.image_url + '/num0.png',
        },
        {
          name: '1',
          value: this.$userList.image_url + '/num1.png',
        },
        {
          name: '2',
          value: this.$userList.image_url + '/num2.png',
        },
        {
          name: '3',
          value: this.$userList.image_url + '/num3.png',
        },
        {
          name: '4',
          value: this.$userList.image_url + '/num4.png',
        },
        {
          name: '5',
          value: this.$userList.image_url + '/num5.png',
        },
        {
          name: '6',
          value: this.$userList.image_url + '/num6.png',
        },
        {
          name: '7',
          value: this.$userList.image_url + '/num7.png',
        },
        {
          name: '8',
          value: this.$userList.image_url + '/num8.png',
        },
        {
          name: '9',
          value: this.$userList.image_url + '/num9.png',
        },
      ],
      contentsList: [],
      information: {},
      date: [],
      formInline: {},
      typeDate: [],
      manager: {},
      datalist:[],
      topValue:{},
      per_client_sale: 0,
      client_stat: 0,
      total_sale: 0,
      dish_count: 0,
    };
  },
  mounted() {
    console.log(this.$userList)
    this.getShops();
    setInterval(() => {
      this.getDate();
    }, 1000);

    setInterval(() => {
      this.getChartsData();
    }, 30000);
  },
  methods: {
    setdropdown(e) {
      this.formInline.shop_id = e.id;
      this.getChartsData();
    },
    //获取门店
    getShops() {
      const url = this.$userList.user_restaurant_list + `/0/999`;
      this.$http.get(url).then(res => {
        if (res.code === 200) {
          this.typeDate = res.data.items;
          this.formInline.shop_id = res.data.items[0].id;
          this.getChartsData();
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    //获取时间
    getDate() {
      const NumberList = ['日', '一', '二', '三', '四', '五', '六'];
      const date = new Date();
      const a = date.getFullYear(); //获取年
      const b = date.getMonth() + 1; //获取月
      const c = date.getDay(); //获取周
      const d = date.getDate(); //获取日
      const e = date.getHours(); //获取小时
      const f = date.getMinutes(); //获取分钟
      const g = date.getSeconds(); //获取秒数
      const h = date.getMilliseconds(); //获取毫秒
      const i = date.getTime(); //1970年一月一直早八点到现在为止的毫秒
      const datea =
        e +
        ':' +
        ((+f < 10 && '0' + f) || f) +
        ':' +
        ((+g < 10 && '0' + g) || g);
      this.date = datea.split('').map(items => {
        this.numberImg.map(itemx => {
          if (itemx.name == items) {
            items = itemx.value;
          }
        });
        return items;
      });
      this.information.data =
        a +
        '-' +
        ((+b < 10 && '0' + b) || b) +
        '-' +
        ((+d < 10 && '0' + d) || d) +
        ' 星期' +
        NumberList[c];
    },
    currentDateStr(is) {
      var myDate = new Date();
        var tYear = myDate.getFullYear();
        var tMonth = myDate.getMonth();
        var Dates =
            myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate();
        var m = tMonth + 1 < 10 ? '0' + (tMonth + 1) : tMonth + 1;
        return tYear + '-' + m + '-' + Dates;
    },
    setDatalist() {
      const data = {};
      this.datalist.map((item) => {
        if (item.indicator.value_type === 'dish_total_price') {
          this.contentsList = item.value
        } else if (item.indicator.value_type === 'device_total_price'){
          this.deviceWeights = item.value
        } else if (item.indicator.value_type === 'device_order_amount_period') {
          this.periods = item.value
        } else if (item.indicator.value_type == 'per_client_sale') {
          this.per_client_sale = item.value.total_price
        } else if (item.indicator.value_type == 'client_stat') {
          this.client_stat = item.value.count
        } else if (item.indicator.value_type == 'total_sale') {
          this.total_sale = item.value.total_price
        }

      });
      this.topValue = data
      // this.tableData = this.topValue.device_order_sale_day.summary
      // console.log('data: ', data);
      // this.topDataMous(data);
      this.drawLine()
    },
    // 获取单位列表
    getChartsData() {
      const shop_id = this.formInline.shop_id
      const data = {
        shop_id,
        indicators: [
          {
            value_type: 'dish_total_price',
            date_type: 'day',
            is_date_range: false,
            date: this.currentDateStr()
          },
          {
            value_type: 'device_total_price',
            date_type: 'day',
            is_date_range: false,
            date: this.currentDateStr()
          },
          {
            value_type: 'device_order_amount_period',
            date_type: 'day',
            is_date_range: false,
            date: this.currentDateStr()
          },
          {
            value_type: "total_sale",
            date_type: "day",
            is_date_range: false,
            date: this.currentDateStr()
          },
          {
            "value_type": "client_stat",
            "date_type": "day",
            "is_date_range": false,
            date: this.currentDateStr()
          },
          // {
          //   "is_date_range": false,
          //   "value_type": "order_stat",
          //   "date_type": "day",
          //   "date": "2022-08-12"
          // },
          {
            "value_type": "per_client_sale",
            "date_type": "day",
            "is_date_range": false,
            date: this.currentDateStr(),
            "date_from": "",
            "date_to": ""
          }
        ],
      }
      const url = this.$userList.show_indicator
      const url2 = this.$userList.stove_weight + shop_id + "/" +  this.currentDateStr()
      this.$http.post(url, data).then((res) => {
        console.log(res)
        if (res.code === 200) {
          this.datalist = res.data.results;
          this.setDatalist();
        }
      });
      this.$http.get(url2).then(res => {
        console.log(res)
        if (res.code === 200) {
          this.deviceList = res.data
          this.deviceList.map(dv => {
            dv.weight = (dv.weight/1000.0).toFixed(2).split('').map(i => {
              this.numberImg.map(j => {
                  if (j.name === i ) {
                    i = j.value;
                  }
                });
                return i
            })

            // dv.volume_real = (dv.volume_real + '').split('').map(i => {
            //   this.numberImg.map(j => {
            //       if (j.name === i ) {
            //         i = j.value;
            //       }
            //     });
            //     return i
            // })
          })
          this.dish_count = res.data.length
        }
      })
    },
    drawLine() {
      let elementById = document.getElementById('echart_A');
      let echartsDemo = this.$echarts.init(elementById);
      const data = [],
          value = [];

      if (this.periods) {
        this.periods.map((item) => {
          data.push(item.hour);
          value.push(item.total_amount/100.0);
        });
      }
      let option = {
        title: {
          text: '营业额',
        },
        tooltip: {
          trigger: 'axis',
        },

        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: data,
        },
        yAxis: {
          type: 'value',

          splitLine: { show: false },
        },
        series: [
          {
            name: '分时营业额',
            type: 'line',
            color: '#66CDAA',
            stack: '总量',
            data: value,
            smooth: true,
            label: {
              show: true,
            },
            lineStyle:{
              width:6
            }
          }
        ],
      };
      echartsDemo.setOption(option);
    },
  },
};
</script>

<style scoped>
.topImg {
  width: 37px;
  height: 27px;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.bg-purple {
  background: #fff;
  box-shadow: 0 0 0px rgba(0, 0, 0, 0.295);
}
.top_ackkitchen {
  width: 100%;
  height: 100%;
  position: relative;
  background: #f0f2f5;
  box-sizing: border-box;
}
.top_ackkitchen_a {
  width: 100%;
  height: 120px;
  background: #282828;
  color: #fff;
  padding: 0%;
  margin: 0%;
  font-size: 44px;
  text-align: center;
  line-height: 120px;
  font-weight: 900;
  position: relative;
}
.top_ackkitchen_as {
  position: absolute;
  left: 40px;
  top: 10px;
}
.name_body {
  width: 100%;
  min-height: 200px;
}
.el-row {
  margin-bottom: 20px;
}
.el-row:last-child {
  margin-bottom: 0;
}
.el-col {
  border-radius: 4px;
}

.grid-content {
  border-radius: 4px;
  /*min-height: 182px;*/
  box-sizing: border-box;
  padding: 20px;
  position: relative;
}
.grid-contents {
  border-radius: 4px;
  max-height: 480px;
  min-height: 100px;
  margin-top: 10px;
  background-color: #fff;
  border-radius: 10px;
  overflow: hidden;
}
.contents_name {
  font-size: 25px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-weight: 900;
  background: #26b5bd;
  color: #fff;
}
.contents_list {
  display: flex;
  box-sizing: border-box;
  padding: 5px 30px;
  justify-content: space-between;
  align-content: center;
}
.borderB {
  width: 100%;
  height: 100%;
  border-bottom: solid 1px rgba(0, 0, 0, 0.1);
  display: flex;
  box-sizing: border-box;
  justify-content: space-between;
  align-content: center;
}
.contents_list_a {
  font-size: 20px;
  width: 25px;
  height: 25px;
  line-height: 25px;
  border-radius: 50%;
  background: #26b5bd;
  text-align: center;
  color: #fff;
  margin-right: 15px;
}
.contents_list_as {
  width: 40px;
  font-size: 20px;
}
.contents_list_b {
  font-size: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.content_bottom {
  position: absolute;
  left: 20px;
  bottom: 0;
  font-size: 15px;
  line-height: 40px;
  border-top: solid 1px rgba(0, 0, 0, 0.3);
  width: 90%;
}
.content_bottoma {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
  margin-bottom: 10px;
}
.content_bottomb {
  font-size: 30px;
  color: rgba(0, 0, 0, 0.85);
}
.content_a {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.content_b {
  min-width: 200px;
}
.size_text {
  font-size: 20px;
}
.name_body_top {
  display: flex;
  flex-wrap: wrap;
}
.name_body_bottom {
  display: flex;
  flex-wrap: wrap;
  border-top: solid 1px rgb(112, 112, 112);
  background-color: #f6eeee;
}
.name_body_bottom_list {
  width: 140px;
  height: 120px;
  background: #fff;
  border-radius: 14px;
  position: relative;
  margin: 10px 10px 10px 0;
  overflow: hidden;
}
.name_body_top_list {
  width: 140px;
  height: 120px;
  background: #fff;
  border-radius: 14px;
  position: relative;
  margin: 10px 10px 10px 0;
  overflow: hidden;
}
.name_body_bottom_value {
  position: absolute;
  left: 70%;
  transform: translateX(-50%);
  top: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.name_body_bottom_img {
  display: flex;
  align-items: flex-end;
  align-content: flex-end;
  font-weight: 900;
  margin-left: 20px;
  margin-top: 5px;
}
.name_body_bottom_img img {
  width: 13px;
  height: 22px;
}
.name_body_top_img {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  font-weight: 900;
  margin-top: 10px;
}
.name_body_top_img img {
  width: 18px;
  height: 32px;
}
.name_body_bottom_g {
  margin-right: 5px;
  margin-top: 20px;
  height: 20px;
}
.name_body_bottom_f {
  margin-left: 20px;
  margin-top: 10px;
  font-size: 20px;
}
.name_body_bottom_name {
  font-size: 15px;
  font-weight: bold;
  text-align: center;
  padding: 5px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.dish_name {
  color: #fff; width: 100%;
  border-radius: 6px 6px 0px 0px;
}
.name_body_top_name {
  font-size: 18px;
  box-sizing: border-box;
  padding: 5px 10px;
  text-align: center;
  background: #ff6827;
  color: #fff;
}
.name_body_bottom_color {
  width: 17px;
  height: 17px;
  border-radius: 50%;
  background: #ff6827;
}
.name_body_icon {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  color: #888;
}
.name_body_icon img {
  width: 24px;
  height: 14px;
  margin-right: 5px;
}
.node_name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 140px;
}
.date_img {
  width: 28px;
  height: 50px;
  margin: 0 2px;
}
.date_value {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: 20px 0px;
}
.date_name {
  font-size: 25px;
  font-weight: 900;
  line-height: 35px;
}
.date_names {
  font-size: 20px;
  line-height: 35px;
  margin-top: 10px;
}
.item_name {
  font-size: 16px;
  width: 100%;
  text-align: left;
  /*margin-top: 10px;*/

  color: #878787;
  box-sizing: border-box;
  overflow: hidden;
}
.iconFloat {
  float: right;
  font-size: 25px;
}

.colMaxBox {
  margin: 5px 0;
}
.item_value {
  font-size: 20px;
  line-height: 40px;
  font-weight: bold;
  width: 100%;
  text-align: left;
  color: #878787;
  box-sizing: border-box;
}
</style>